<mat-card *ngIf="((lastMatches$ | async) && (lastMatches$ | async).length > 0 ) || ((nextMatches$ | async) && (nextMatches$ | async).length > 0)" mat-stretch-tabs mat-align-tabs="center" class="m-b-16" style="padding: 0px;background-color:transparent">
  <div *ngIf="(nextMatches$ | async).length > 0 && (nextMatches$ | async); let nextMatches;">
    <mat-card-title><h2 [ngClass]="{'p-t-8': home == true, 'p-b-8': home == true}" [ngStyle]="{'text-align': home ? 'left' : 'center'}">{{ 'matches.nextMatches' | translate }}</h2></mat-card-title>
    <mat-card-content class="matero-row m-t-0" fxLayout="row wrap" fxLayoutAlign="stretch" style="display: flex;
    flex-wrap: wrap;padding:0px!important">
      <ng-container *ngFor="let match of nextMatches.slice(0,7);let e = index">
        <!-- <hr *ngIf="e !== 0" class="hr"> -->
        <app-match-tile
        class="matero-col" fxFlex="100" [fxFlex.gt-sm]="home == true ? 25 : 100" style="margin-bottom: 8px;display: flex;height: auto;"
                [routerLink]="sharedService.buildRoute(['matches', match.id])"
                [localMember]="match.localMember"
                [visitorMember]="match.visitorMember"
                [thirdMember]="match.thirdMember"
                [localTeam]="match.localTeam"
                [visitorTeam]="match.visitorTeam"
                [thirdTeam]="match.thirdTeam"
                [match]="match"
                [widget]="true">
        </app-match-tile>
      </ng-container>
      <!-- <div *ngIf="(nextMatches$ | async)?.length > 0" class="matero-col" fxFlex="100" [fxFlex.gt-sm]="home == true ? 25 : 100" style="margin-bottom: 8px;display: grid;height: auto;align-items: center;">
        <button mat-button color="primary" [routerLink]="sharedService.buildRoute(['matches'])">{{ 'general.show_more' | translate }} {{ 'ROUTES.matches' | translate }}</button>
      </div> -->
    </mat-card-content>
  </div>
  <div *ngIf="(lastMatches$ | async).length > 0 && (lastMatches$ | async); let lastMatches;">
    <mat-card-title><h2 [ngClass]="{'p-t-16': home == true, 'p-b-8': home == true}" [ngStyle]="{'text-align': home ? 'left' : 'center'}">{{ 'matches.lastMatches' | translate }}</h2></mat-card-title>
    <mat-card-content class="matero-row m-t-0" fxLayout="row wrap" fxLayoutAlign="stretch" style="display: flex;
    flex-wrap: wrap;padding:0px!important">
      <ng-container *ngFor="let match of lastMatches.slice(-7);let e = index">
        <!-- <hr *ngIf="e !== 0" class="hr"> -->
        <app-match-tile
        class="matero-col" fxFlex="100" [fxFlex.gt-sm]="home == true ? 25 : 100" style="margin-bottom: 8px;display: flex;height: auto;"
                [routerLink]="sharedService.buildRoute(['matches', match.id])"
                [localTeam]="match.localTeam"
                [visitorTeam]="match.visitorTeam"
                [thirdTeam]="match.thirdTeam"
                [localMember]="match.localMember"
                [visitorMember]="match.visitorMember"
                [thirdMember]="match.thirdMember"
                [match]="match"
                [widget]="true">
        </app-match-tile>
      </ng-container>
      <!-- <div *ngIf="(lastMatches$ | async)?.length > 0" class="matero-col" fxFlex="100" [fxFlex.gt-sm]="home == true ? 25 : 100" style="margin-bottom: 8px;display: grid;height: auto;align-items: center;">
        <button mat-button color="primary" [routerLink]="sharedService.buildRoute(['matches'])">{{ 'general.show_more' | translate }} {{ 'ROUTES.matches' | translate }}</button>
      </div> -->
    </mat-card-content>
  </div>

</mat-card>




